import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import { Link } from 'react-router-dom'

const FViewRepUsr = () => {
    const [total, setTotal] = useState(0)
    const [reparto, setReparto] = useState([])
    const { setFormView, setViewOpen, idUsuario, modify } = useContext(ContextStates)
    

    useEffect(() => {
        const consultaRepartos = async () => {
            const formData = new FormData()
            console.log("idusuario ", idUsuario)
            formData.append("idusuario", idUsuario)
            try {
                const response = await axios({
                    url: Url + 'api/getReparto.php',
                    method: 'POST',
                    data: formData,
                })
                //console.log("reparto ", response)
                setReparto(response.data.results[0])
            } catch (e) {
                console.log(e)
            }
        }
        consultaRepartos()
    }, [modify])

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof reparto.productos !== 'undefined') {
                reparto.productos.forEach(element => {
                    t = t + parseInt(element.montoventas)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [reparto])

    return (
        <div className="w-full py-5 px-2 md:px-20 rounded-2xl">
            { typeof reparto!=='undefined' && (
                <>
            <h2 className='text-center text-gray-700 text-xl'>Reparto {reparto.fecha}</h2>
            {reparto.apellido && (
                <div className='w-full mx-auto p-10'>
                    <p className='text-center text-lg'>Repartidor: {reparto.apellido}</p>
                </div>
            )}
            {reparto.productos && (
                <table className='w-full md:w-3/4 mx-auto'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white text-center'>
                            <th>Producto</th>
                            <th>Lleva</th>
                            <th>Trae</th>
                            <th>Suma</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            reparto.productos.map((item, index) => (
                                <tr key={index} className='border border-gray-300 p-2 text-center'>
                                    <td>{item.descripcion}</td>
                                    <td>{item.cantidadinicial}</td>
                                    <td>{item.cantidadfinal}</td>
                                    <td>$ {parseFloat(item.montoventas).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</td>
                                </tr>
                            ))
                        }
                        <tr className='border border-gray-300 p-2 text-center'>
                            <th colSpan={3}>Total</th>
                            <th>$ {parseFloat(total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</th>
                        </tr>
                    </tbody>
                </table>
            )}
            {reparto.mediosventas && reparto.mediosventas.map((item, index) => (
                <p key={index} className='font-bold text-center'>{item.mediopago} - $ {parseFloat(item.total).toLocaleString("es-AR", { maximumFractionDigits: 2 })}</p>
            ))}
            <div className="w-1/2 md:w-1/3 mx-auto rounded-lg px-3 flex justify-center mt-10 print:hidden">
                <Link className='w-full' to={"/"}>
                <button
                    type="button"
                    className="w-full mx-auto shadow-md p-3 ml-3 bg-gray-500 text-white hover:bg-gray-400 transition-all uppercase font-bold rounded-lg"
                    >
                    Volver a Ventas
                </button>
                </Link>
            </div>
                </>                
            )} 
        </div>
    )
}

export default FViewRepUsr